import axios from 'axios';

import {baseUrl} from './../constants/apiConstants';
import {dispatchClearLoginInfo, login} from './loginActions';
import {dispatchClearOtp, verifyOtp} from './verifyOtpActions';
import {getCurrentAffairs,dispatchClearCurrentAffairs,getFullContentCurrentAffairs,dispatchClearFullCurrentAffairs } from './currentAffairsAction';
import { getHomeInfo, dispatchClearHomeInfo } from './getHomeInfoActions';
import { adsInfo,clearAdsInfo } from './adsInfoActions';
import {getTestSeriesList, clearTestSeriesList} from './testSeriesListAction';
import {getUserToken} from './getUserToken';
import {clearAllPaymentForCreateTestData, checkoutCreateTest} from './paymentForCreateTestActions';
import { getTestSeriesTestList, clearTestSeriesTestList } from './testSeriesTestListAction';
import { clearSingleTestInfoData, getSingleTestInfo } from './getSingleTestInfoActions.js';
import { clearTestAnalysisData,testAnalysis } from './testAnalysisAction';
import { questionReport,clearQuestionReportData } from './questionReportAction';
import { getTest, selectedAnswers, changeQuestion, markedQuestions, clearTest, timeSpend } from './startTestAction'
import { getAllTestsInfo, clearAllTestsData } from './getAllTestAction';
import { submitTest, clearSubmitTestData } from './submitTestAction';
import {clearTestTermsAndConditionsData , getTestTermsAndConditions} from './testTermsAndConditionAction' 
import { registation,dispatchClearRegistation} from './registrationActions';

import { clearUserNameVerify, userNameVerify } from './userNameVerifyAction';
import {verifyOtpForRegistration,dispatchClearRegistrationOtpVerify} from './registrationVerifyOtpAction';
import { getExams, dispatchClearExams} from './getExamsAction';
import { getCourses, clearAllCoursesData} from './getCoursesAction';
import { getLessonPlanner , clearLessonPlannerData} from './getlessonPlannerAction'
import { getCourseMaterial , clearAllCourseMaterialData} from './getCoureMaterialAction'
import { clearLibrarySubjectsData, getLibrarySubjects  } from './getLibrarySubjectsAction'
import { getLibraryTopicsBySubject, clearLibraryTopicsBySubjectData  } from './getTopicLibraryBySubjectIdAction'
import { getLibraryContentInfo, clearLibraryContentData  } from './getLibraryContentAction'
import { getGetHtmlContent, dispatchClearGetHtmlContent  } from './getHtmlContnetInfoAction'
import { getAboutUs, clearAboutUsData  } from './aboutScreenAction';
import { getAppTermsAndConditions, clearAppTermsAndConditionsData  } from './appTermsAndConditionsAction';
import { getDiscalimer, clearDisclaimerData  } from './disclaimerAction';
import { getPrivacyAndPolicy, clearPrivacyAndPolicyData } from  './privacyAndPolicyAction';
import { changePhoneNumber, clearChangePhoneNumber} from './changePhoneNumberAction';
import { verifyChangePhoneNumber, clearVerifyChangePhoneNumber} from './verifyChangeNumberAction';   
import { updateProfile, clearUpdateProfileData} from './updatedProfileAction';   
import { getUpdateProfile, clearGetUpdateProfile } from './getUpdatedProfileAction';  
import { uploadProfilePic, clearUploadProfileData } from './uploadProfilePicAction' ;
import { dispatchClearLogout, logout } from './logoutActions';
import { getCurrentAffairsListForPagination, dispatchClearGetCurrentAffairsListForPagination } from './getCurrentAffairsWiithPaginationAction'
import { clearGetJwPlayerSourceFiles, getGetJwPlayerSourceFiles } from './getJwPlayerSourceFileAction'
import { clearAllFacultyListInfoData , getAllFacultyList } from './getAllFacultyInfoListActions';
import { getSubjectMentors, clearSubjectMentors } from './subjectsMentorsActions';
import { getBookMarks, clearBookMarksData, deleteBookMark, clearDeleteBookMarkData, addBookMark, clearAddBookMarkData} from './bookMarkActions';




axios.interceptors.response.use(function (response) {
    // console.log(response, 'axios success');
     return response;
   }, function (error) {   
    //  console.log(error.response, 'axios error response')
     if(error?.response?.data?.message == "Unauthorized") return window.location.pathname = '/';
     if(error.response && error.response.status === 502) alert('server error, please try again after some time');
     return Promise.reject(error);
   });

export {
    login,
    dispatchClearLoginInfo,
    dispatchClearOtp,
    verifyOtp,
    getCurrentAffairs,
    dispatchClearCurrentAffairs,
    getFullContentCurrentAffairs,
    dispatchClearFullCurrentAffairs,
    getHomeInfo, 
    dispatchClearHomeInfo,
    adsInfo,clearAdsInfo,  
    getTestSeriesList,
    clearTestSeriesList,
    getUserToken,
    getTestSeriesTestList,
    clearTestSeriesTestList,
    clearAllPaymentForCreateTestData, 
    checkoutCreateTest,
    clearSingleTestInfoData, getSingleTestInfo,
    clearTestAnalysisData,
    testAnalysis,
    questionReport,
    clearQuestionReportData,
    getTest,
    selectedAnswers, 
    changeQuestion, 
    markedQuestions, 
    clearTest,
    timeSpend,
    getAllTestsInfo,
    clearAllTestsData,
    submitTest,
    clearSubmitTestData ,
    clearTestTermsAndConditionsData , 
    getTestTermsAndConditions,
    baseUrl,
    registation,
    dispatchClearRegistation,
    clearUserNameVerify,
    userNameVerify,
    verifyOtpForRegistration,
    dispatchClearRegistrationOtpVerify,
    getExams,
    dispatchClearExams,
    getCourses,
    clearAllCoursesData,
    getLessonPlanner,
    clearLessonPlannerData,
    getCourseMaterial,
    clearAllCourseMaterialData ,
    getLibrarySubjects ,
    clearLibrarySubjectsData,
    clearLibraryTopicsBySubjectData,
    getLibraryTopicsBySubject,
    getLibraryContentInfo,
    clearLibraryContentData,
    dispatchClearGetHtmlContent,
    getGetHtmlContent,
    getAboutUs,
    clearAboutUsData,
    getAppTermsAndConditions,
    clearAppTermsAndConditionsData,
    getDiscalimer, 
    clearDisclaimerData,
    getPrivacyAndPolicy, 
    clearPrivacyAndPolicyData,
    changePhoneNumber, 
    clearChangePhoneNumber,
    clearVerifyChangePhoneNumber,
    verifyChangePhoneNumber,
    updateProfile, 
    clearUpdateProfileData,
    getUpdateProfile,
    clearGetUpdateProfile,
    uploadProfilePic,
    clearUploadProfileData,
    dispatchClearLogout,
    logout,
    getCurrentAffairsListForPagination,
    dispatchClearGetCurrentAffairsListForPagination,
    clearGetJwPlayerSourceFiles, 
    getGetJwPlayerSourceFiles ,
    getBookMarks,
    clearBookMarksData,
    deleteBookMark,
    clearDeleteBookMarkData,
    addBookMark,
    clearAddBookMarkData,
    clearAllFacultyListInfoData , 
    getAllFacultyList,
    getSubjectMentors, 
    clearSubjectMentors, 
    
}